module.exports = __webpack_public_path__ + "static/media/programming-language.0dfb35b5.svg";